import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const BCBenxehangtable = React.memo(function BCBenxehangtable(props) {
  const classes = useStyles();
  const { data } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đơn vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>
            Tổng số bến xe hàng trên địa bàn
          </td>
          <td className={classes.tablebc_td}>đơn vị</td>
          <td className={classes.tablebc_td}>{data.bh_sodonvi}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>
            Tổng số lượt phương tiện ra, vào các bến
          </td>
          <td className={classes.tablebc_td}>lượt xe</td>
          <td className={classes.tablebc_td}>{data.bh_luotphuongtien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>
            Tổng khối lượng hàng hoá thông qua tại các bến
          </td>
          <td className={classes.tablebc_td}>1000 tấn</td>
          <td className={classes.tablebc_td}>{data.bh_khoiluonghanghoa}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div>
      <table className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCBenxehangtable.propTypes = {
  data: PropTypes.object,
};
export default BCBenxehangtable;
